<template>
  <gj-modal
      :visible.sync="modalVisible"
      :size="'normal'"
      @cancel="cancel"
      @confirm="confirm"
      :confirm-loading="loading"
      notFooterPadding
  >
    <template #header>
      {{item === null ? '添加' : '编辑'}}角色
    </template>
    <template #content>
      <el-form :model="form" label-width="80px" ref="roleForm">
        <el-form-item label="角色名称" prop="name" :rules="[
                  { required: true, message: '请输入角色名称', trigger: 'blur' },
                  { min: 1, max: 20, message: '限制1-20个字符', trigger: 'blur' },
              ]">
          <gj-input v-model="form.name" width="100%"></gj-input>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {addRole, updateRole} from "../../../../../api/setting";

  export default {
    name: "role-edit-modal",
    mixins: [modalMixIn],
    props: {
      item: null,
    },
    created() {
      if (this.item !== null) {
        this.form.id = this.item.id;
        this.form.name = this.item.text;
      }
    },
    data() {
      return {
        loading: false,
        form: {
          id: null,
          name: null,
        }
      }
    },
    methods: {
      confirm() {
        if (!this.formValidate()) {
          return
        }
        this.loading = true;
        if (this.item === null) {
          addRole(this.form).then(response => {
            if (response.isSuccess) {
              this.$message.success("新增成功");
              this.$emit('after', response.data);
            } else {
              this.$message.error(response.msg)
            }
          }).catch(response => {
            this.$message.error(response.msg)
          }).complete(() => {
            this.loading = false;
          })
        } else {
          updateRole(this.form).then(response => {
            if (response.isSuccess) {
              this.$message.success("修改成功");
              this.$emit('after', null);
            } else {
              this.$message.error(response.msg)
            }
          }).catch(response => {
            this.$message.error(response.msg)
          }).complete(() => {
            this.loading = false;
          })
        }

      },
      formValidate() {
        let formValid = false;
        this.$refs.roleForm.validate((valid) => {
          formValid = valid;
        });
        return formValid;
      },
    }
  }
</script>

<style scoped>

</style>
